<template lang="pug">
	div
		.card
			.wrapper
				.card__title(v-text="page.name" data-aos="fade-up")
				.card__subtitle(v-text="page.name_latin" data-aos="fade-up")
				img.card__image(:src="page.photo ? page.photo[1200] : ''" data-aos="fade-up" data-aos-delay="200")
				.wrapper.wrapper_min
					.card__text(v-html="page.content" data-aos="fade-up")
					.card__label(v-text="page.subtitle" data-aos="fade-up")
					.card__list(data-aos="fade-up")
						.card__item(v-for="(item, index) in page.characteristics" :key="index")
							.card__prop(v-if="item.name" v-text="item.name")
							.card__val(v-if="item.value" v-text="item.value")
		.section(v-if="page.full_products && page.full_products.length")
			.wrapper
				.section__title(data-aos="fade-up") Пов’язані продукти
				.section__swiper-container.section__swiper-container_1(data-aos="fade-up" data-aos-delay="200")
					swiper.section__swiper(v-if="showSliders && page.full_products && page.full_products.length && getCatalogById(page.full_products[0].catalogs[0])" ref="swiper1"
						:options="{allowTouchMove: false,loop: (page.full_products.length <= 4 ? false : true),slidesPerView: 4,navigation: {nextEl: '.section__swiper-container_1 .section__arrow_right',prevEl: '.section__swiper-container_1 .section__arrow_left'}, breakpoints: {1200: {slidesPerView: 'auto',allowTouchMove: true}}}"
					)
						swiperSlide(
							v-for="(card, index) in page.full_products"
							:key="index"
						)
							section-card(
								:card="card"
								:type="'product'"
								:link="'/products/' + getCatalogById(card.catalogs[0]).slug + '/' + card.slug + '/'"
							)
					template(v-if="page.full_products.length > 4")
						button.section__arrow.section__arrow_left
						button.section__arrow.section__arrow_right
				.section__bottom(data-aos="fade-up")
					router-link.section__more(to='/products/') Всі продукти
						span
		.section(v-if="page.full_cultures && page.full_cultures.length")
			.wrapper
				.section__title(data-aos="fade-up") Пов’язані культури
				.section__swiper-container.section__swiper-container_1(data-aos="fade-up" data-aos-delay="200")
					swiper.section__swiper(v-if="showSliders && page.full_cultures && page.full_cultures.length" ref="swiper2"
						:options="{allowTouchMove: false,loop: (page.full_cultures.length <= 4 ? false : true),slidesPerView: 4,navigation: {nextEl: '.section__swiper-container_1 .section__arrow_right',prevEl: '.section__swiper-container_1 .section__arrow_left'}, breakpoints: {1200: {slidesPerView: 'auto',allowTouchMove: true}}}"
					)
						swiperSlide(
							v-for="(card, index) in page.full_cultures"
							:key="index"
						)
							section-card(
								:card="card"
								:type="'culture'"
								:link="'/cultures/' + card.slug + '/'"
							)
					template(v-if="page.full_cultures.length > 4")
						button.section__arrow.section__arrow_left
						button.section__arrow.section__arrow_right
				.section__bottom(data-aos="fade-up")
					router-link.section__more(to='/cultures/') Всі культури
						span
</template>

<script>

	import sectionCard from '@/components/sectionCard.vue';
	import 'swiper/dist/css/swiper.css'
	import { swiper, swiperSlide } from 'vue-awesome-swiper';
	import {mapGetters} from 'vuex';

	export default {
		name: 'Card',
		props: {
			page: Object
		},
		data: function(){
			return {
				showSliders: true
			}
		},
		computed: {
			...mapGetters([
				'getCatalogById'
			])
		},
		mounted() {
			window.addEventListener('resize', this.resizeHandler, false);
		},
		destroyed() {
			window.removeEventListener('resize', this.resizeHandler, false);
		},
		methods: {
			resizeHandler() {
				// this.showSliders = false;
				setTimeout(() => {
					// this.showSliders = true;
					if (this.$refs.swiper1) this.$refs.swiper1.swiper.update();
					if (this.$refs.swiper2) this.$refs.swiper2.swiper.update();
				});
			}
		},
		components: {
			'section-card': sectionCard,
			swiper,
			swiperSlide
		}
	}

</script>

<style lang="scss" scoped>

	@import '@/helpers/sass/kit.scss';

	.card {
		margin-top: 75px;
		margin-bottom: 100px;
		letter-spacing: .7px;

		&__title {
			font: 700 28px/34px 'Helvetica', Arial, sans-serif;
			letter-spacing: 1px;
		}

		&__subtitle {
			margin-top: 23px;
			font: 300 18px/23px 'Helvetica', Arial, sans-serif;
			letter-spacing: 0.05em;
		}

		&__image {
			margin-top: 41px;
			display: block;
			width: 100%;
		}

		&__text {
			margin-top: 40px;
		}

		.wrapper {
			max-width: 846px;
		}

		&__label {
			margin-top: 50px;
			font: 700 21px/1 'Helvetica', Arial, sans-serif;
			letter-spacing: 1px;
		}

		&__list {
			margin-top: 27px;
			font: 300 14px/18px 'Helvetica', Arial, sans-serif;
		}

		&__item {
			margin-bottom: 15px;
		}

		&__prop {
			display: inline-block;
			vertical-align: top;
			margin-right: 5px;
		}

		&__val {
			display: inline-block;
			vertical-align: top;
			font-weight: 700;
		}

		.wrapper_min {
			max-width: 630px;
		}
	}

	.section {
		margin: 94px 0;

		&__title {
			@include kit('sectionTitle');
			margin-left: 0;
		}

		&__swiper {
			width: calc(100% + 20px);
			margin-left: -10px;
		}

		&__swiper-container {
			position: relative;
			margin-top: 16px;
		}

		&__arrow {
			position: absolute;
			top: 20px;
			width: 50px;
			height: 50px;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
			background-color: #EF3E33;
			z-index: 1;

			&_left {
				background: url('../assets/img/arr_2.svg') #EF3E33 no-repeat center center;
				left: -50px;
			}

			&_right {
				background: url('../assets/img/arr_1.svg') #EF3E33 no-repeat center center;
				right: -50px;
			}
		}

    >>> .card {
			margin-bottom: 57px;
			margin-top: 20px;
		}

		&__bottom {
			text-align: center;
		}

		&__more {
			height: 50px;
			width: 296px;
			max-width: 100%;
			border: 1px solid #EF3E33;
			position: relative;
			display: inline-block;
			vertical-align: top;
			text-transform: uppercase;
			margin-top: 23px;
			padding-right: 50px;
			text-align: center;
			color: #EF3E33;
			font: 500 19px/52px 'Helvetica', Arial, sans-serif;
			letter-spacing: 2px;
			position: relative;

			span {
				display: block;
				position: absolute;
				top: 0;
				right: 0;
				width: 50px;
				height: 100%;
				background: url('../assets/img/arr_3.svg') no-repeat center center;
				border-left: 1px solid #EF3E33;
			}
		}
	}

	@media screen and (max-width: 1200px) {
		.card {
			margin-top: 50px;

			.wrapper {
				padding: 0;
			}

			&__subtitle {
				margin-top: 20px;
			}

			&__image {
				margin-top: 20px;
			}

			&__text {
				margin-top: 30px;
			}
		}

		.section {

			.wrapper {
				padding: 0;
			}

			&__arrow {
				display: none;
			}

			&__more {
				margin-top: 50px;
			}

			.section__swiper-container {
				width: calc(100% + 40px);
				margin-left: 0px;
			}

      >>> .swiper-slide {
				padding: 0 10px;
				width: 266px;
			}

      >>> .card {
				width: 246px;
				margin: 0;
			}
		}
	}

</style>
